import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TDaiyoZyomuinTeateListGetReq,
  TDaiyoZyomuinTeateListGetRes,
  TDaiyoZyomuinTeatePutReq,
} from "./TDaiyoZyomuinTeate"

/**
 * 大陽乗務員手当に対するAPIリクエスト用サービス
 *
 * @export
 * @class DaiyoZyomuinTeateService
 * @extends {ConnectApi}
 */
export default class DaiyoZyomuinTeateService extends ConnectApi {
  /**
   * 一覧取得
   *
   * @param {TDaiyoZyomuinTeateListGetReq} params
   * @memberof DaiyoZyomuinTeateService
   */
  getList = async (params: TDaiyoZyomuinTeateListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TDaiyoZyomuinTeateListGetRes[]>> =
        await this.getInner(`/billing/taiyozyomuinteate/register`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 手当 更新
   *
   * @param {TDaiyoZyomuinTeatePutReq} data
   * @memberof DaiyoZyomuinTeateService
   */
  put = async (data: TDaiyoZyomuinTeatePutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/taiyozyomuinteate/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体取得
  //    *
  //    * @param {TMenuInfoGetReq} params
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
  //    * @memberof MenuService
  //    */
  //   get = async (id: string | number) => {
  //     try {
  //       // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
  //       // await this.getInner(`/master/hinmei`, params)
  //       //return res.data
  //       if (id === "3") {
  //         // eslint-disable-next-line no-throw-literal
  //         throw "ERROR"
  //       }

  //       return {
  //         data: dummyData[0],
  //       }
  //       //TODO: api実装必要
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体登録
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   post = async (data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //         `master/hinmei/`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}
